/* eslint-disable */


import React, { useEffect, useRef,useState } from "react";
import { motion } from 'framer-motion';
import { Link as RouterLink} from 'react-router-dom';


// material
import { styled } from '@mui/material/styles';
import { Box, Button,TextField, Typography,FormControl,Select,MenuItem,InputLabel , Container } from '@mui/material';

// components
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';
import { findLastIndex } from "lodash";



// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));




// ----------------------------------------------------------------------

export default function ComingSoon() {

  

  return (
    <RootStyle title="Coming Soon ">
      <Container>

        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                Coming Soon !
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              This feature is coming soon,keep checking this space.
            
            </Typography>


            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src="/static/icons/coming_soon.jpg"
                sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 5 } }}
              />
            </motion.div>

          
 
            <Button to="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button>
          </Box>
        </MotionContainer>




       
      </Container>
    </RootStyle>
  );
}
